<template>
  <div id="app">
    <div id="my-content">
      <img alt="Logo" class="logo" src="./assets/logo.jpg" />
      <div class="socal-links">
        <a href="https://www.facebook.com/CincyXmasLights/">Facebook</a> |
        <a href="https://www.instagram.com/cincyxmaslights/">Instagram</a>
      </div>
      <hr />
      <div class="row my-menu">
        <div class="col"><router-link to="/">Displays</router-link></div>
        <div class="col"><router-link to="/categories">Categories</router-link></div>
        <div class="col"><a href="https://cooldisplays.net/index.php?page=state&state=LOC">Map</a></div>
        <div class="col"><router-link to="/myvotes">My Votes</router-link></div>
      </div>
      <hr />
      <router-view></router-view>
      <div class="hosting">
        <hr />Hosting provided by:
        <br />
        <a href="https://cooldisplays.net">
          <img src="https://cooldisplays.net/images/logo/RGB/logo_rgb_270x129.png" />
        </a>
      </div>
    </div>
  </div>
</template>

<script>
import "regenerator-runtime";
export default {
  name: "app",
  components: {}
};
</script>

<style>
#my-content {
  padding-top: 40px;
  max-width: 750px;
  margin-left: auto;
  margin-right: auto;
  background-color: white;
  border: 2px;
  border-style: solid;
  border-radius: 25px;
}
#app {
  background-color: darkred;
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}
.logo {
  border-radius: 50%;
}
.hosting {
  margin-top: 2em;
}
.socal-links {
  margin-top: 0.5em;
}
.action-bar {
  text-align: left;
  margin-left: 1em;
}
</style>
